import React, { useContext,useEffect,useState } from "react";
import Fade from "react-reveal/Fade";
import Dashboard from "../../components/Dashboard/Dashboard";
import { UserContext } from "../../components/UserContext";
import Cookies from "js-cookie"
import { useSnackbar } from "notistack"
import axios from "axios"
import "./History.css";

const url = "https://www.bitmasta.io/php/functioned.php"
const History =(props)=>{
  const { enqueueSnackbar } = useSnackbar();
  const user = useContext(UserContext);
  const [transacts,setTransacts] = useState([]);
  const [loading,setLoading] = useState(true);
  useEffect(() => {
    const fetchData = () => {
      let formData = new FormData();
      formData.append("Active_User",user.user||Cookies.get("auth"))
      formData.append("Transact",true)
      try{
        
      axios.post(url,formData).then(res=>{
        if(res.data.status === "Transactions Found"){
          setLoading(false)
          setTransacts(res.data.Data)
        }
        else{
          setLoading(false)
          setTransacts([])
        }
      })
      }
      catch(err){
      enqueueSnackbar(err, {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      })
      }
    }
    fetchData()
  }, [user,enqueueSnackbar])
    return (
      <Dashboard {...props} back={()=>props.history.push("/dashboard")}>
        <Fade className="bts-history">
          <div className="col-md-12 col-sm-12">
            <div className="scroll">
              <div className="bts-history-wrapper d-flex pb-3">
                <span className="b7">Date</span>
                <span className="b7">Transaction</span>
                <span className="b7">Amount</span>
                <span className="b7">Status</span>
              </div>
              {
                !loading ?
                  transacts.length > 0 ?
                    transacts.map((trans,i)=>(
                      <div key={i} className="bts-history-list d-flex">
                      <span>{trans.Date}</span>
                    <span className={`b7 ${trans.Type === "Buy" ?"buy":"sell"}`}>{trans.Type}</span>
                    <span>{trans.Amount}</span>
                    <span>{trans.Status}</span>
                    </div>
                    ))
                  : <p>
                  No Transaction Found
                </p>
                : 
                <p>
                  Loading...
                </p>
              }
             

            </div>
          </div>
        </Fade>
      </Dashboard>
    );
  }

export default History;